import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@frontend/components/ui/dialog';
import { useDirectoryChannels } from '@frontend/shared/hooks/useDirectory';
import { useSingleSearchParam } from '@frontend/shared/hooks/useSingleSearchParam';

export function AppSuccessModal() {
  const [success, setSuccess] = useSingleSearchParam('success');

  let channels = useDirectoryChannels({
    requireQbInChannel: true,
    excludeDeleted: true,
  });
  channels = [...channels, ...channels, ...channels, ...channels];

  const renderedChannel = channels.map((c) => (
    <a
      key={c.id}
      href={`https://slack.com/app_redirect?channel=${c.id}`}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block text-blue-600 font-bold hover:underline"
    >
      #{c.name}
    </a>
  ))[0];

  return (
    <Dialog open={!!success} onOpenChange={() => setSuccess(undefined)}>
      <DialogContent className="max-w-xl">
        {success === 'integration' && (
          <>
            <DialogHeader>
              <DialogTitle>🎉 Integration connected</DialogTitle>
            </DialogHeader>
            <div className="pb-6">
              <p>
                Your data is syncing.
                <br />
                Once done, you can ask questions in Slack
              </p>
              <p className="mt-2">{renderedChannel}</p>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
